import { formatAmount, formatAmountCompact } from '../../../Utils/billingoDocuments';

// Amounts in different currencies never add up, so a total is a list: "€120.00
// + 50,000 Ft". A currency that sums to nothing is dropped rather than shown as
// "+ 0 Ft" — it says nothing and costs the room the real number needs.
const entries = (byCurrency = {}) => Object.entries(byCurrency)
  .filter(([, amount]) => Math.abs(Number(amount) || 0) > 0.005);

/** Exact, for tooltips and body text. */
export const fullAmounts = (byCurrency) => entries(byCurrency)
  .map(([cur, amount]) => formatAmount(amount, cur))
  .join(' + ');

/** Compact, for a stat tile that must not overflow its card. */
export const compactAmounts = (byCurrency) => entries(byCurrency)
  .map(([cur, amount]) => formatAmountCompact(amount, cur))
  .join(' + ');
